import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo',
  standalone: false,
})
export class YesNoPipe implements PipeTransform {
  transform(value: boolean | undefined): string {
    if (value == null) return '';

    if (value == true) return 'Yes';
    else return 'No';
  }
}